<template>
  <div class="new-npi-grouping">
    <b-modal ref="mapGroupRef" :title="$t('COMMON.ADD_NPI_GROUPING')" @shown="focusOnInput" @hide="cancelNewNpiGrouping" class="modal-info" centered>
      <b-container fluid>
        <b-row class="mb-3">
          <b-col cols="3">{{ $t('COMMON.NAME') }}</b-col>
          <b-col>
            <b-form-input type="text" v-model="key" :placeholder="$t('COMMON.GROUP_NAME')" ref="groupName"></b-form-input>
            <div v-if="key && !isKeyUnique" style="color:red">{{ $t('COMMON.MSG_KEY_UNIQUE') }}</div>
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col cols="3">NPI</b-col>
          <b-col>
            <b-form-select :plain="true" :options="groupTypes" v-model="group.npi" placeholder="NPI" :state="!$v.group.npi.$invalid">
              </b-form-select>
            <b-form-invalid-feedback id="input2LiveFeedback">{{ $t('COMMON.MSG_REQ_FIELD') }}
              </b-form-invalid-feedback>
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col cols="3">{{ $t('COMMON.PRESCRIBER_FIRST_NAME') }}</b-col>
          <b-col>
            <b-form-select :plain="true" :options="groupTypes" v-model="group.firstName" placeholder="First Name">
            </b-form-select>
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col cols="3">{{ $t('COMMON.PRESCRIBER_LAST_NAME') }}</b-col>
          <b-col>
            <b-form-select :plain="true" :options="groupTypes" v-model="group.lastName" placeholder="Last Name">
            </b-form-select>
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col cols="3">{{ $t('COMMON.PRESCRIBER_NAME') }}</b-col>
          <b-col>
            <b-form-select :plain="true" :options="groupTypes" v-model="group.name" placeholder="Name">
            </b-form-select>
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col cols="3">{{ $t('DATA_TYPE.CITY') }}</b-col>
          <b-col>
            <b-form-select :plain="true" :options="groupTypes" v-model="group.city" placeholder="City">
            </b-form-select>
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col cols="3">{{ $t('DATA_TYPE.STATE') }}</b-col>
          <b-col>
            <b-form-select :plain="true" :options="groupTypes" v-model="group.state" placeholder="State">
            </b-form-select>
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col cols="3">{{ $t('DATA_TYPE.ZIPCODE') }}</b-col>
          <b-col>
            <b-form-select :plain="true" :options="groupTypes" v-model="group.zip" placeholder="ZipCode">
            </b-form-select>
          </b-col>
        </b-row>
      </b-container>
      <div slot="modal-footer" class="w-100 d-flex justify-content-end">
        <b-btn size="sm" class="float-right" variant="primary mr-1" :disabled="$v.$invalid || !isKeyUnique" @click="createNewNpiGrouping">{{$t('COMMON.ADD')}}</b-btn>
        <b-btn size="sm" class="float-right" variant="light" @click="cancelNpiGrouping">{{$t('COMMON.CANCEL')}}</b-btn>
      </div>
    </b-modal>
    <b-modal :title="'New-Npi-Grouping'" hide-header-close centered ok-only ok-variant="secondary" @ok="clearGrouping" ref="agnetNewNpiGroupingModal">
      <p>You are not permitted to access this. Kindly contact administrator</p>
    </b-modal>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'

export default {
  props: ['mappingsKeys', 'showNewNpiGrouping', 'templateMappings'],
  data () {
    return {
      key: null,
      group: {
        npi: null,
        firstName: null,
        lastName: null,
        name: null,
        city: null,
        state: null,
        zip: null
      },
      groupTypes: [
        { value: null, text: this.$t('COMMON.MSG_SELECT_TYPE') }
      ],
      isKeyUnique: false
    }
  },
  validations: {
    group: {
      npi: {
        required
      }
    }
  },
  computed: {
    ...mapGetters(['isAdminRole'])
  },
  watch: {
    key: function (key) {
      this.isKeyUnique = key ? (this.mappingsKeys.indexOf(key.toLowerCase().replace(/\s/g, '')) === -1) : false
    },
    showNewNpiGrouping: function () {
      if (this.showNewNpiGrouping) {
        if (this.isAdminRole) {
          this.key = null
          this.group.npi = null
          this.group.firstName = null
          this.group.lastName = null
          this.group.name = null
          this.group.city = null
          this.group.state = null
          this.group.zip = null
          let mappings = this.templateMappings.find('Rect').filter(function (shape) {
            return shape.attrs.edit_type === 'created'
          })
          mappings = mappings.map(map => map.attrs)
          mappings.map((child) => {
            if (!child.parentDataType) {
              this.groupTypes.push({value: child.key, text: child.key})
            }
          })
          this.$refs.mapGroupRef.show()
        } else {
          this.$refs.agnetNewNpiGroupingModal.show()
        }
      } else {
        this.groupTypes = [
          { value: null, text: 'Please select type' }
        ]
        this.$refs.mapGroupRef.hide()
      }
    }
  },
  methods: {
    focusOnInput () {
      this.$refs.groupName.focus()
    },
    clearGrouping () {
      this.$refs.agnetNewNpiGroupingModal.hide()
      this.$emit('cancelled')
    },
    createNewNpiGrouping () {
      this.$emit('created', this.key, this.group)
    },
    cancelNpiGrouping () {
      this.$refs.mapGroupRef.hide()
      this.$emit('cancelled')
    },
    cancelNewNpiGrouping () {
      this.$emit('cancelled')
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/templates/newNpiGrouping.vue